<template>
  <div id="modal_popup_campaign_details" class="modal-popup">
    <div class="modal-popup-content">
      <a @click="showModalPopup('modal_popup_campaign_details', false)" class="close-button">
        <img src="@/assets/images/close-button.svg" />
      </a>
      <div class="d-inline-block" v-if="this.campaign">
        <div class="offer-details-wrapper">
          
          <div class="d-flex flex-row justify-content-around align-items-center">
            <h5>
              <i>{{$t('widgetField')}} </i> {{" " +  (this.campaign.widget_type)}}
            </h5>
            <h5>
              <i>{{$t('categoryField')  }} </i> {{ " " +  (this.campaign.category) }}
            </h5>
            <h5>
              <i>{{$t('priorityField')  }} </i> {{ " " + (this.campaign.priority) }}
            </h5>
          </div>
          <div class="d-flex flex-row justify-content-around">
            <label>
              start: {{ this.campaign.start_date }}
            </label>
            <label>
              end: {{ this.campaign.end_date }}
            </label>
          </div>
          <div class="d-flex flex-row justify-content-around" v-if="this.campaign.partner">
             <h5> <i>{{ $t('partnerField') + ": " }} </i> {{ this.campaign.partner.name + (this.campaign.partner.fiscal ? " (" + this.campaign.partner.fiscal + ")" : "" )}} </h5>
          </div>
          <div class="d-flex flex-column align-items-baseline ">
            <!-- <small class="text-break">{{ $t("cmsLang.productLabel") }}</small> -->
            <!-- <input type="text" v-model="newCampaign.category" class="formedituser w-100" /> -->
            <div class="radioButtonCustom">
              <label v-for="(product, index) in this.campaignProducts" :key="index">
                <input name="channeltype" type="radio" :value="product" disabled
                    :checked="true">
                {{ $t('cmsLang.product_' + product) }}</label>
              </div>
            </div>
            <div class="d-flex flex-column align-items-baseline ">
            <!-- <small class="text-break">{{ $t("cmsLang.productLabel") }}</small> -->
            <!-- <input type="text" v-model="newCampaign.category" class="formedituser w-100" /> -->
            <div >
              <label v-for="(location, index) in this.campaign.location" :key="index">
                {{ location.name  }}
                </label>
              </div>
            </div>
          <div class="d-flex flex-row justify-content-around" v-if="this.campaign.i18">
            <div class="border-color-11"  v-for="(texts, index) in this.campaign.i18" :key="index">
              <h5 >{{ texts.title }}</h5>
              <div  class="offer-preview-image" :style="{ 'background-image': `url(${texts.url_image})` }"></div>
            </div>
          <!-- <p class="description" v-if="this.campaign.i18" v-html="this.campaign.i18[0].description"></p> -->
          <!-- <p class="description" v-if="this.campaign.i18" v-html="this.campaign.i18[1].description"></p> -->
           </div>
          <div class="details-wrapper" v-if="this.campaign.status === 'N' || this.campaign.status === 'I'">
            <div class="row d-flex flex-row ">
              <a @click="approveGame()" class="button-all button-yellow" v-if="isUserAdmin(user)">
                {{ $t('cmsLang.approveLabel') }}

              </a>
              <a @click="editGameDetails()" class="edit">
                <img src="@/assets/images/cms-mkt/edit.svg" />
              </a>
              <a @click="deleteGame()" class="delete">
                <img src="@/assets/images/cms-mkt/delete.svg" />
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from "@/plugins/utils.js";

  export default {
    name: "GameDetailsPopup",

    props: {
      user: Object,
      campaign: Object,
      image: String,
      gameType: String,
      currency: String,
    },
    data() {
      return {
      };
    },
    methods: {
      editGameDetails() {
        this.$emit("edit", this.campaign);
      },
      deleteGame() {
        this.$emit("delete", this.campaign);
      },
      approveGame() {
        this.$emit("approve", this.campaign);
      },
      gameImage() {
        if (this.campaign.image) {
          return "data:image/png;base64," + this.campaign.image
        } else {
          return require('@/assets/images/cms-mkt/offer_0.svg');
        }
      }

    },
    computed: {
      campaignProducts() {
        let filteredProducts = null;
        if (this.campaign.filters) {
          this.campaign.filters.forEach((filter) => {
            if (filter.type === "product") {
              filteredProducts = filter.values.id;
            }
          })
        }
        return filteredProducts;
      }
    },
  };
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style scoped src="@/assets/styles/cms-commercial.css"></style>
<style scoped>
  .position {
    position: relative;
    left: 227px;
  }

  .contact-details-wrapper {
    justify-content: space-evenly;
  }

  i {
    padding-right: 10px;;
  }

</style>
